import ProjectListContainer from "../../../../Component/Application/Project/ProjectList/ProjectList"

const ProjectList = () => {
  return (
    <div className='page-body'>
      <ProjectListContainer />
    </div>
  )
}

export default ProjectList